export const USERS_SET = 'USERS_SET';
export const USERS_ERROR = 'USERS_ERROR';
export const USERS_USER_CREATE = 'USERS_USER_CREATE';
export const USERS_USER_RESET = 'USERS_USER_RESET';
export const USERS_TOGGLE_LOADING = 'USERS_TOGGLE_LOADING';
export const USERS_TOGGLE_FILTERS = 'USERS_TOGGLE_FILTERS';
export const USERS_RESET = 'USERS_RESET';
